"use strict";
var Observable_1 = require('../../Observable');
var switch_1 = require('../../operator/switch');
Observable_1.Observable.prototype.switch = switch_1._switch;
Observable_1.Observable.prototype._switch = switch_1._switch;
//# sourceMappingURL=switch.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/add/operator/switch.js
// module id = 1111
// module chunks = 0